import {
  ORDER_SESSION_KEYS,
  getStoredSessionValue,
  setIfChanged,
} from "./orderSession.utils";

export const getShopId = () => {
	return getStoredSessionValue(ORDER_SESSION_KEYS.shopId);
};

export const setShopId = (shopId: string) => {
  setIfChanged(ORDER_SESSION_KEYS.shopId, shopId);
};

export const getTagId = () => {
	return getStoredSessionValue(ORDER_SESSION_KEYS.tagId);
};

export const setTagId = (tagId: string) => {
  setIfChanged(ORDER_SESSION_KEYS.tagId, tagId);
};

export const getOrderTableId = () => {
	return getStoredSessionValue(ORDER_SESSION_KEYS.orderTableId);
};

export const setOrderTableId = (orderTableId: string) => {
  setIfChanged(ORDER_SESSION_KEYS.orderTableId, orderTableId);
};

export const getUniqueId = () => {
	return getStoredSessionValue(ORDER_SESSION_KEYS.uniqueId);
};

export const setCurrencyCode = (currencyCode = "NGN") => {
  setIfChanged(ORDER_SESSION_KEYS.currencyCode, currencyCode);
};

export const getCurrencyCode = () => {
  return getStoredSessionValue(ORDER_SESSION_KEYS.currencyCode) || "NGN";
};

export const getQrc = () => {
  return getStoredSessionValue(ORDER_SESSION_KEYS.qrc);
};

export const setQrc = (qrc: string) => {
  setIfChanged(ORDER_SESSION_KEYS.qrc, qrc);
};
